/**
 * Shared mapping of Firebase authentication error codes to user-friendly
 * messages. Both the sign-in and forgot-password screens surface Firebase auth
 * errors, but they translate them under different key namespaces
 * (`auth.errors.*` vs `auth.forgotPassword.*`). The caller therefore supplies
 * the code-to-key map plus a default key, and this helper resolves the
 * translation. Each screen keeps its exact existing behaviour.
 */

type TranslateFn = (key: string) => string;

type FirebaseAuthErrorMessageOptions = {
  /** Maps a Firebase error code to the translation key for that screen. */
  codeToKey: Record<string, string>;
  /** Translation key used when the code has no specific mapping. */
  defaultKey: string;
};

export function getFirebaseAuthErrorMessage(
  errorCode: string,
  translate: TranslateFn,
  { codeToKey, defaultKey }: FirebaseAuthErrorMessageOptions,
): string {
  const key = codeToKey[errorCode];
  if (key === undefined) {
    return translate(defaultKey);
  }
  return translate(key);
}
